'use client';
import styled from 'styled-components';

import { PatchedLink } from '@utils/patched-link';

export const CardWrapper = styled(PatchedLink)`
  &&& {
    position: relative;
    width: 100%;

    &:hover {
      opacity: 1;
    }
  }
`;

export const Card = styled.div`
  position: relative;
  box-shadow: 0px 0px 8px 0px rgba(0, 17, 68, 0.08);
  min-width: 282px;
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  background-color: ${({ theme }) => theme.palette.white};

  &:hover {
    .campainCard__image {
      transform: scale(1.1);
    }

    .campaignCard__title {
      color: ${({ theme }) => theme.palette.primaryBrand};
    }
  }

  .campaignCard__title {
    transition: color 0.3s ease;
  }
`;

export const CardImageWrapper = styled.div`
  position: relative;
`;

export const CardImageInnerWrapper = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 1 / 1;

  & > img {
    object-fit: cover;
    transition: all 0.5s ease-out;
  }
`;

export const ExpirationDateWrapper = styled.div`
  position: absolute;
  top: 20px;
  right: -6px;
  background-image: url('/static/images/empty-popper-ico.svg');
  width: 100px;
  height: 46px;
  display: flex;
  justify-content: center;
  padding-top: 10px;
  font-size: 12px;
  color: ${({ theme }) => theme.palette.darkGray};
`;

export const BottomRightImageWrapper = styled.div<{
  backgroundImageUrl: string;
}>`
  position: absolute;
  top: 126px;
  right: -6px;
  background-image: url(${({ backgroundImageUrl }) => backgroundImageUrl});
  width: 100px;
  height: 46px;
`;

export const CardContent = styled.div`
  background-color: ${({ theme }) => theme.palette.white};
  display: flex;
  flex-direction: column;
  padding: 24px 16px;
`;

export const CardTitle = styled.p`
  text-align: left;
  color: ${({ theme }) => theme.palette.grey1100};
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  margin-bottom: 0px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  height: 50px;

  overflow: hidden;

  ${({ theme }) => theme.mediaQueries.LARGE_1X_UP} {
    font-size: 16px;
    font-weight: 500;
  }
`;
